<template>
  <div class="mb-16 base-card-wrapper">
    <div class="sub-card-wrapper">
    <BaseListItemCard
      size="sm"
      class="grid grid-cols-12 gap-4 items-center w-full"
    >
      <div class="flex col-span-10 items-center">
        <InlineSvg class="icon-sm-2 mr-20 flex-shrink-0 " :src="icon"></InlineSvg>
        <span
          :class="[{ 'text-red-500': isError }]"
          class="name text-base-span-md whitespace-normal"
          v-safe-html="text"
        ></span>
      </div>
      <div class="flex items-center col-span-2">
        <span
          class="ml-8 text-base-span-md overflow-hidden text-ellipsis whitespace-nowrap"
        >{{ date }}</span>
      </div>
    </BaseListItemCard>
  </div>
  </div>
</template>

<script>
export default {
  name: "ItemHistory",
  props: {
    date: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    colorIcon: {
      type: String,
      required: false
    },
    text: {
      type: String,
      required: true
    },
    item: {
      type: Object,
      required: true
    },
    isError: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      required: true
    }
  }
};
</script>
